<template>
  <div>
    <custom-animation :data="animationData" class="hour-glass"></custom-animation>
  </div>
</template>

<script>
import CustomAnimation from '../CustomAnimationWithLottieWithoutModal';
import hourGlass from './hourGlass.json';

export default {
  components: {
    CustomAnimation
  },
  data() {
    return {
      animationData: hourGlass
    }
  }
};
</script>

<style lang="scss" scoped>
.hour-glass {
  // transform: scale(5);
}
</style>
